module.exports = __webpack_public_path__ + "static/media/lowsugar.69344be4.jpg";